import { Otp } from '@repo/shared/components'
import { useTranslate } from '@repo/shared/hooks'
import { useAgentEmailOtp, useAgentSetUserEmail } from '@repo/services'
import { Button, Col, onCloseModal, toast } from '@repo/ui/components'
import { useRef, useState } from 'react'
import { IChangeEmailKycOtpProps } from './change-email-kyc.types'
import { useErrorHandler } from '@repo/shared/hooks'
export const ChangeEmailKycOtp = (props: IChangeEmailKycOtpProps) => {
  const { email, otp, handleBack } = props
  const { t } = useTranslate()

  const [otpCode, setOtpCode] = useState<string>('')
  const emailOtpMutation = useAgentEmailOtp()
  const setUserEmailMutation = useAgentSetUserEmail({ invalidate: true })
  const { errorHandler } = useErrorHandler()
  const submitRef = useRef(null)

  const handleResend = () => {
    emailOtpMutation.mutate({ email: email }, { onError: errorHandler })
  }

  const handleOtpComplete = (code: string) => {
    setOtpCode(code)
  }

  const handleSubmit = async (code: string = otpCode) => {
    if (!code || code.length !== 5) return
    setUserEmailMutation.mutate(
      { email: email, otp: Number(otp), code },
      {
        onError: errorHandler,
        onSuccess: () => {
          toast.success({
            title: t('changeEmailKyc_success'),
          })
          setUserEmailMutation.reset()
          onCloseModal()
        },
      },
    )
  }

  return (
    <Col className='gap-3xl mt-md'>
      <Otp
        mobileOrEmail={email}
        onResend={handleResend}
        onComplete={handleOtpComplete}
        onEdit={handleBack}
        focusRef={submitRef}
      />
      <Button
        ref={submitRef}
        size='lg'
        className='w-full'
        onClick={() => handleSubmit()}
        disabled={otpCode.length !== 5}
        loading={setUserEmailMutation.isPending}
      >
        {t('common_verify')}
      </Button>
    </Col>
  )
}
